import { render, staticRenderFns } from "./PagesBar.vue?vue&type=template&id=e8ef519a&"
import script from "./PagesBar.vue?vue&type=script&lang=js&"
export * from "./PagesBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports